export type KeyValue = Record<string, unknown>;

export const isObject = (value: unknown): value is KeyValue =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

export const hasContent = (value: unknown): boolean => {
  if (Array.isArray(value)) return value.length > 0;
  if (isObject(value)) return Object.keys(value).length > 0;
  return value !== undefined && value !== null && value !== '';
};

export const getNumericCode = (value: unknown): number | undefined => {
  if (typeof value !== 'number' && typeof value !== 'string') return undefined;

  const numericCode = Number(value);
  return Number.isFinite(numericCode) ? numericCode : undefined;
};

export const getFailureCode = (...values: unknown[]): number | undefined => {
  for (const value of values) {
    const numericCode = getNumericCode(value);
    if (numericCode && numericCode >= 400) return numericCode;
  }

  return undefined;
};

export const toIdentifier = (value: string): string => {
  if (/[-_]/.test(value)) {
    const [firstWord, ...otherWords] = value
      .split(/[-_]+/)
      .filter(Boolean)
      .map(word => word.toLowerCase());

    return [
      firstWord,
      ...otherWords.map(word => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
    ].join('');
  }

  if (value === value.toUpperCase()) return value.toLowerCase();
  return `${value.charAt(0).toLowerCase()}${value.slice(1)}`;
};

export const toSafeReason = (value: unknown, fallback: string): string => {
  if (typeof value !== 'string' || !/^[a-z0-9_-]{1,64}$/i.test(value)) {
    return fallback;
  }

  return toIdentifier(value) || fallback;
};
